<script>
import {
  shippingMethodLddEmits,
  shippingMethodLddProps,
  useShippingMethodLdd
} from "./mixin";
import AddressLadSelector from "@/containers/adresses-lad/adress-lad-selector";
import InfoComplementaires from "@/containers/shipping-method/shipping-method-ldd/info-complementaires";

export default {
  name: "ShippingMethodLad",
  components: {
    AddressLadSelector,
    InfoComplementaires
  },
  props: {
    ...shippingMethodLddProps()
  },
  emits: [...shippingMethodLddEmits()],
  setup(props, context) {
    const { updateModeCommande } = useShippingMethodLdd(context);
    return { updateModeCommande };
  }
};
</script>

<template>
  <div>
    <AddressLadSelector :check-eligibilite="false" />

    <template v-if="addresseLad">
      <InfoComplementaires
        :addresse-lad="addresseLad"
        :infos-legales="service.info_non_retrait"
        @updateModeCommande="updateModeCommande"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-address-mobile.scss";
</style>
